
import { HeadersService } from './headers.service';
import { UserStorageService } from './user-storage.service';
import { tap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment as env } from 'src/environments/environment';
import { Response } from '../login/login models/response';

@Injectable({
  providedIn: 'root'
})
export class GetService {

  constructor(private ht: HttpClient, private storage: UserStorageService, private headers: HeadersService) { }

  login(data) {

    return this.ht.post(`${env.apiUrl}login`, data).pipe(
      tap((data: Response) => {this.storage.setUserData(data.response)}))

        }

  logout() {
    // remove user from local storage to log user out
      localStorage.clear();
  }



  get(url: string, params?: Array<any>): Observable<any> {

    return this.ht.get(env.apiUrl + url, this.headers.setHeaders())
  }
  getById(url: string, id, params?: Array<any>): Observable<any> {

    return this.ht.get(env.apiUrl + url + "/" + id, this.headers.setHeaders())
  }
  Post(url: string, data, params?: Array<any>): Observable<any> {
    return this.ht.post(env.apiUrl + url, data, this.headers.setHeaders())
  }
  Delete(url:string, id, params?:Array<any>){
return this.ht.delete(env.apiUrl+url+id, this.headers.setHeaders())
  }
}
